import React, {useContext} from 'react';
import CbtNavbar from './CbtNavbar';
import ChatroomSidebar from './ChatroomSidebar';
import TeachersChat from './TeachersChat'
import ChatSwitch from './common/ChatSwitch';
import Sidebar from './Sidebar';
import {DataContext} from '../context/DataContext';
import { animated, useSpring } from "react-spring";
import FooterNav from './FooterNav';
import { AuthContext } from '../context/AuthContext'

const CbtShell = ({children}) => {
    const authContext = useContext(AuthContext);
    const toggleMobileChat = authContext.toggleMobileChat
    const dataContext = useContext(DataContext);
    const showMenu = dataContext.showMenu;
    const groupChat = dataContext.groupChat;
    const teachers = dataContext.teachers;
    const transitionStylesSidebar = useSpring({
        to: [
            { transform: 'translateX(0px)' },
        ],
        from: { transform: 'translateX(-160px)' },
        config: { duration: 750 }
    });

    const transitionStylesChatpage = useSpring({
        to: [
            { transform: 'translateX(0px)' },
        ],
        from: { transform: 'translateX(160px)' },
        config: { duration: 750 }
    });
        return (
        <>
            <div className="bg-gray-600 h-screen">
                <div className="border-b border-gray-600 w-full bg-white">
                    <CbtNavbar />
                </div>
                {showMenu && 
                <div className='mt-16'>
                    <Sidebar />
                </div>
                }
                <div className="sm:flex w-full bg-gray-700 mt-16 mb-auto sm:mb-0">
                    <animated.div style={transitionStylesSidebar} className="flex flex-col sm:bg-white border-right rounded-lg w-full sm:w-1/5 z-0 pt-8 sm:px-4">
                        <div className="hidden sm:block mt-1 h-8 mx-auto sm:mx-0 sm:w-full w-2/3">
                            <ChatSwitch />
                        </div>
                        {groupChat && !toggleMobileChat ?
                        <div className="block sm:bg-white z-0 h-screen w-full">
                            <ChatroomSidebar />
                        </div> :
                        groupChat && toggleMobileChat && window.innerWidth > 640 &&
                        <div className="block sm:bg-white z-0 h-screen w-full">
                            <ChatroomSidebar />
                        </div>
                        }
                        {/* {teachers && 
                        <div className="sm:bg-white z-0 w-full">
                            <TeachersChat />
                        </div>
                        } */}
                    </animated.div>
                    {window.innerWidth > 640 && !toggleMobileChat ?
                    <animated.div style={transitionStylesChatpage} className="block sm:px-1  w-full sm:w-4/5 pl-0 sm:pl-16">
                        <div onClick={() => authContext.setToggleMobileChat(!toggleMobileChat)} className='block sm:hidden'> Back </div>
                        {children}
                    </animated.div> :
                    window.innerWidth < 640 && toggleMobileChat ?
                    <animated.div style={transitionStylesChatpage} className="block sm:px-1  w-full sm:w-4/5 pl-0 sm:pl-16">
                        <div onClick={() => authContext.setToggleMobileChat(!toggleMobileChat)} className='block'> Back </div>
                        {children}
                    </animated.div> :
                    window.innerWidth > 640 && toggleMobileChat &&
                    <animated.div style={transitionStylesChatpage} className="block sm:px-1  w-full sm:w-4/5 pl-0 sm:pl-16">
                        <div onClick={() => authContext.setToggleMobileChat(!toggleMobileChat)} className='hidden'> Back </div>
                        {children}
                    </animated.div>
                    }
                </div>
                <div className='w-full sm:hidden z-10 relative flex justify-between left-0 bottom-0'>
                    <FooterNav />
                </div>
            </div>
        </>
    );
}

export default CbtShell;